import React, { useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import { ViewDetailIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { openURLInNewTab } from 'utils/navigation';

const linkStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  cursor: 'pointer',
  color: 'primary.main',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
};

const carrierLabelStyles = {
  color: 'text.secondary',
  ml: '4px',
};

const TrackingValue = ({ value, trackingInfo }) => {
  const handleClick = useCallback(
    e => {
      e.preventDefault();
      openURLInNewTab(trackingInfo?.url);
    },
    [trackingInfo?.url],
  );

  if (!trackingInfo) {
    return <Typography variant="bold16">{value}</Typography>;
  }

  return (
    <Box className="flex items-center gap-4">
      <Box
        component="a"
        href={trackingInfo.url}
        rel="noopener noreferrer"
        sx={linkStyles}
        target="_blank"
        onClick={handleClick}
      >
        <Typography color="primary.main" variant="bold16">
          {value}
        </Typography>
        <ViewDetailIcon size={IconSize[16]} />
      </Box>
      <Typography sx={carrierLabelStyles} variant="regular12">
        {trackingInfo.carrier}
      </Typography>
    </Box>
  );
};

TrackingValue.propTypes = {
  value: PropTypes.string,
  trackingInfo: PropTypes.shape({
    carrier: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
};

export default TrackingValue;
